<template>
<div id="secure">

    <section class="main-content columns is-full">
        <div class="container column is-12" style="padding: 10px; margin-top: 15px;">
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>

            <div class="card is-hidden1">
                <div class="card-header">
                    <p class="card-header-title maintitle">Leaderboard ({{ monthDisplay }} {{ actionYear }}) 
                        <span class="last-refresh">(Last refresh at {{ currentDate }}, {{ currentTime }})</span>
                    </p>
                    <b-select id="duration" name="duration" v-model="duration" class="header-input" @input="getLeaderboard()">
                        <option selected value="0">Whole Year</option>
                        <option selected value="1">January</option>
                        <option selected value="2">February</option>
                        <option selected value="3">March</option>
                        <option selected value="4">April</option>
                        <option selected value="5">May</option>
                        <option selected value="6">June</option>
                        <option selected value="7">July</option>
                        <option selected value="8">August</option>
                        <option selected value="9">September</option>
                        <option selected value="10">October</option>
                        <option selected value="11">November</option>
                        <option selected value="12">December</option>
                        <option selected value="2019">2019</option>
                    </b-select>
                </div>
                <div class="card-content">

                    <div class="columns">
                        <div class="column is-half">
                            <loading :active.sync="isLoading1" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                            <div class="card">
                                <div class="card-header">
                                    <p class="card-header-title subtitle">By Students</p>
                                </div>
                                <div class="card-content">
                                    <div class="content">
                                        <div class="columns">    
                                            <div class="column">#</div>
                                            <div class="column is-two-fifths">Student</div>
                                            <div class="column is-one-third">Class</div>
                                            <div class="column is-one-fifth">Points</div>
                                        </div>
                                        <div class="columns top-border" v-for="(top,index) in sortTop(topStudents)" :key="top._id" v-show="topStudents.length > 0">
                                            <div class="column">{{ index + 1 }}</div>
                                            <div class="column is-two-fifths">{{ top.firstName }} {{ top.lastName }}</div>
                                            <div class="column">{{ top.kelasID.level }} {{ top.kelasID.name }}</div>
                                            <div class="column is-one-fifth text-center">{{ roundTo2DecimalPlaces(top.tempNumber1) }}</div>
                                        </div>
                                        <span v-show="topStudents.length == 0" class="inline-error-message">{{ topStudentsErrorMessage }}</span>
                                    </div>
                                </div>
                            </div>
                            <br />
                        </div>
                        <div class="column is-half">
                            <loading :active.sync="isLoading2" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                            <div class="card">
                                <div class="card-header">
                                    <p class="card-header-title subtitle">By Class</p>
                                </div>
                                <div class="card-content">
                                    <div class="content">
                                        <div class="columns">    
                                            <div class="column">#</div>
                                            <div class="column is-three-fifths">Class</div>
                                            <div class="column is-one-fifth">Points</div>
                                        </div>
                                        <div class="columns top-border" v-for="(top,index) in sortTop(topClass)" :key="top._id" v-show="topClass.length > 0">
                                            <div class="column">{{ index + 1 }}</div>
                                            <div class="column is-three-fifths">{{ top.level }} {{ top.name }}</div>
                                            <div class="column is-one-fifth text-center">{{ roundTo2DecimalPlaces(top.tempNumber1) }}</div>
                                        </div>
                                        <span v-show="topClass.length == 0" class="inline-error-message">{{ topClassErrorMessage }}</span>
                                    </div>
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <br />
        </div>

    </section>    
</div>
</template>

<script>
import axios from 'axios'
import "./public/style.scss";
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';


export default {
    name: "LeaderboardV1Full",
    components: {
        Loading,
    },
    data() {
        return {
            isLoading1: false,
            isLoading2: false,
            dateDisplay: '',
            actionDate: 0,
            actionMonth: 0,
            actionYear: 0,
            duration: 1,
            monthDisplay: '',
            topStudents: [],
            topClass: [],
            topStudentsErrorMessage: '',
            topClassErrorMessage: '',
            lastRefresh: '',
            timer: '',
            currentDate: '',
            currentTime: '',
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
        console.log("before mount hoho");
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    created() {
        var getCurrentDate = new Date();
        var currentDay = getCurrentDate.getDate();
        if (getCurrentDate.getDate() < 10){
            currentDay = "0" + currentDay;
        }
        this.actionYear = getCurrentDate.getFullYear()
        var currentMonth = getCurrentDate.getMonth() + 1;  //since month starts from 0
        this.duration = currentMonth
        this.actionMonth = currentMonth;
        if (currentMonth < 10){
            currentMonth = "0" + currentMonth;
        }
        this.actionDate = this.actionYear + "" + currentMonth + "" + currentDay;
        console.log("actionDate: " + this.actionDate)

        var month = getCurrentDate.getMonth();
        var dayOfWeek = getCurrentDate.getDay();

        var dayOfWeekDisplay = "";
        switch (dayOfWeek){
            case 0:
                dayOfWeekDisplay = "Sunday";
                break;
            case 1:
                dayOfWeekDisplay = "Monday";
                break;
            case 2:
                dayOfWeekDisplay = "Tuesday";
                break;
            case 3:
                dayOfWeekDisplay = "Wednesday";
                break;
            case 4:
                dayOfWeekDisplay = "Thursday";
                break;
            case 5:
                dayOfWeekDisplay = "Friday";
                break;
            case 6:
                dayOfWeekDisplay = "Saturday";
                break;
            default:
                dayOfWeekDisplay = "Monday";
                break;
        }

        var monthDisplay = this.getMonthDisplay(month);

        this.monthDisplay = monthDisplay;
        this.dateDisplay = dayOfWeekDisplay + ", " + getCurrentDate.getDate() + " " + monthDisplay + " " + getCurrentDate.getFullYear();

        var time = getCurrentDate.getHours() + ":" + getCurrentDate.getMinutes() + ":" + getCurrentDate.getSeconds();
        this.currentTime = time;

        this.currentDate = currentDay + " " + monthDisplay + " " + getCurrentDate.getFullYear();
        this.timer = setInterval(this.getLeaderboard, 60000 * 10 * 60)    //60 minutes
    },
    mounted(){
        this.getTopStudents()
        this.getTopClass()
    },
    methods: {
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){            
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        getLeaderboard(){
            
            var getCurrentDate = new Date();

            var day = getCurrentDate.getDate();
            var month = this.getMonthDisplay(getCurrentDate.getMonth());

            this.currentDate =  day + " " + month + " " + getCurrentDate.getFullYear();
            var time = getCurrentDate.getHours() + ":" + getCurrentDate.getMinutes() + ":" + getCurrentDate.getSeconds();
            this.currentTime = time;

            this.getTopStudents()
            this.getTopClass()
        },
        sortTop(arrays){
            return _.orderBy(arrays, 'tempNumber1', 'desc').splice(0,100);  //we're using the magical lodash function here to sort by points and return the only top 100
        },
        roundTo2DecimalPlaces(points){  //use lodash to round the points to 2 decimal places
            return _.round(points, 2)
            // return _.round(points, 2).toFixed(2)
        },
        viewClassDashboard(id,name){
            this.$store.commit('UPDATE_CLASSES_DASHBOARD_SINGLE_ID',id)
            this.$store.commit('UPDATE_CLASSES_DASHBOARD_SINGLE_NAME',name)
            localStorage.setItem('CLASSES_DASHBOARD_SINGLE_ID',id)
            localStorage.setItem('CLASSES_DASHBOARD_SINGLE_NAME',name)
            
            console.log("store.getClassesDashboardSingleID: " + this.$store.getters.getClassesDashboardSingleID);

            this.$router.push({
                name: "ClassDashboardSingle"
            });
        },
        getTopStudents(){
            let self = this;
            this.isLoading1 = true;

            var show = 'all';

            if (self.duration == 0){
                show = 'all';
                self.monthDisplay = "";
            }else if (self.duration == 2019){
                console.log("236 duration 2019")
                show = 'previousYear_2019';
            }else{
                show = 'monthly'
                self.actionMonth = self.duration
                self.monthDisplay = this.getMonthDisplay(self.actionMonth - 1)  //since getMonthDisplay count starts at 0
            }
            
            console.log("233 entering getTopStudents")
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.timeout = 0
            axios.post(process.env.MY_URL + '/api/students/positive/leaderboard', {
                    params: {
                        email: localStorage.getItem('email'),
                        category: 'student',
                        show: show,
                        limit: 20,
                        actionYear: self.actionYear,
                        actionMonth: self.actionMonth
                    }
                })
                .then(response => {
                    if (response.data.success){
                        self.topStudents = response.data.content
                    }else{
                        self.topStudentsErrorMessage = response.data.msg
                        self.topStudents = []
                    }
                    self.isLoading1 = false
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading1 = false
                })
        },
        getTopClass(){
            let self = this;
            this.isLoading2= true;

            var show = 'all';

            if (self.duration == 0){
                show = 'all';
            }else if (self.duration == 2019){
                console.log("279 duration 2019")
                show = 'previousYear_2019';
            }else{
                show = 'monthly'
                self.actionMonth = self.duration
            }

            console.log("263 entering getTopClass")
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.timeout = 0
            axios.post(process.env.MY_URL + '/api/students/positive/leaderboard', {
                    params: {
                        email: localStorage.getItem('email'),
                        category: 'school',
                        show: show,
                        limit: 20,
                        actionYear: self.actionYear,
                        actionMonth: self.actionMonth
                    }
                })
                .then(response => {                    
                    if (response.data.success == false){
                        self.topClassErrorMessage = response.data.msg
                        self.topClass = []
                    }else{
                        self.topClass = response.data
                    }
                    self.isLoading2 = false
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading2 = false
                })
        },
        goDbKelas() {
            this.$router.push({
                name: "KelasMain"
            });
        },
        getMonthDisplay(month){
            month = parseInt(month)
            var monthDisplay = "";
            switch (month){
                case 0:
                    monthDisplay = "January";
                    break;
                case 1:
                    monthDisplay = "February";
                    break;
                case 2:
                    monthDisplay = "March";
                    break;
                case 3:
                    monthDisplay = "April";
                    break;
                case 4:
                    monthDisplay = "May";
                    break;
                case 5:
                    monthDisplay = "June";
                    break;
                case 6:
                    monthDisplay = "July";
                    break;
                case 7:
                    monthDisplay = "August";
                    break;
                case 8:
                    monthDisplay = "September";
                    break;
                case 9:
                    monthDisplay = "October";
                    break;
                case 10:
                    monthDisplay = "November";
                    break;
                case 11:
                    monthDisplay = "December";
                    break;
                default:
                    monthDisplay = "";
                    break;
            }
            return monthDisplay;
        }
    }
};
</script>

<style scoped>
.content{
    font-weight: bold;
    font-size: 1.2rem;
}
.last-refresh{
    font-weight: normal;
    font-size: 0.9rem;
    font-style: italic;
    margin-left:20px;
}
.kelas-button{
    margin-right: 10px;
    margin-bottom: 10px;
}
.header-tag{
    float: right !important;
    border: 1px solid #209cee;
    color: #209cee;
    padding-bottom: calc(0.375em - 1px);
    padding-left: 0.75em;
    padding-right: 0.75em;
    padding-top: calc(0.375em - 1px);
    align-items: center;
    border-radius: 4px;
    font-size: 1.2rem;
    height: 2.25em;
    line-height: 1.5;
    margin: 10px;
}
.maintitle{
    font-size: 30px;
}
.subtitle{
    font-size: 20px;
}
.header-date{
    float: right;
    padding: 10px;
}
.attendance-pie{
    width: 250px;
    height: 250px;
}
.header-input{
    margin: 10px;
}
.header-icon{
    margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/LeaderboardV1Full.vue